import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBoletines } from 'services/servicioGet';
import { Boletin } from 'utils/models/types';

interface BoletinesState {
  boletines: Boletin[];
  loadingBoletines: boolean;
  errorBoletines: string | null;
}

// Estado inicial del slice
const initialState: BoletinesState = {
  boletines: [],
  loadingBoletines: false,
  errorBoletines: null,
};

// Thunk para obtener los boletines
export const fetchBoletines = createAsyncThunk('email/fetchBoletines', async (_, { rejectWithValue }) => {
  try {
    const response = await getBoletines();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de boletines
const boletinesSlice = createSlice({
  name: 'boletines',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBoletines.pending, state => {
        state.loadingBoletines = true;
        state.errorBoletines = null;
      })
      .addCase(fetchBoletines.fulfilled, (state, action) => {
        state.boletines = action.payload;
        state.loadingBoletines = false;
      })
      .addCase(fetchBoletines.rejected, (state, action) => {
        state.loadingBoletines = false;
        state.errorBoletines = action.payload as string;
      });
  },
});

export default boletinesSlice.reducer;
